export enum ProgrammeType {
  DE = "DE",
  EE = "EE",
}
